import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ShopProvider } from './context/ShopContext';
import { ThemeProvider } from './context/ThemeContext';
import { DiscountProvider } from './context/DiscountContext';
import ScrollToTop from './components/common/ScrollToTop';
import AppLayout from './AppLayout';
import './App.css';

function App() {
    return (
        <Router>
            <ThemeProvider>
                <DiscountProvider>
                    <ScrollToTop />
                    <ShopProvider>
                        <AppLayout />
                    </ShopProvider>
                </DiscountProvider>
            </ThemeProvider>
        </Router>
    );
}

export default App;
